import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'callout payment-request {{if @isSelected \"enable\" \"disable\"}}\' ...attributes>\n  <div class=\'grid-x grid-padding-x\' data-test-on-select {{on \'click\' @onSelect}}>\n    <div class=\'cell medium-9\'>\n      {{yield to=\'header\'}}\n    </div>\n    <div class=\'cell medium-3 text-right\'>\n      {{yield to=\'logo\'}}\n    </div>\n  </div>\n  {{yield to=\'content\'}}\n</div>");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      Presentational callout wrapper for one payment method entry
 *              (enabled/disabled styling, click-to-select, named block slots)
 *   extends:   Component (@glimmer/component)
 *   template:  payment-section.hbs
 *   args:      @isSelected, @onSelect (read in the template, not in this file)
 *   uses:      -
 *   siblings:  ../payment-method.js (parent, renders one instance per PSP with
 *              header/logo/content block content)
 *   tests:     none
 *
 * No own logic — a templateless-style wrapper whose template yields three named
 * blocks (header, logo, content) so the parent composes each payment method's
 * markup while this component only owns the selectable-callout chrome.
 */
class PaymentMethodPaymentSectionComponent extends Component {}
setComponentTemplate(TEMPLATE, PaymentMethodPaymentSectionComponent);

export { PaymentMethodPaymentSectionComponent as default };
//# sourceMappingURL=payment-section.js.map
